if(document.querySelector('.related-products__container .columns-4')) {
  var el = document.querySelector('.related-products__container .columns-4');
  el.classList.add('swiper-wrapper');
}

if(document.querySelectorAll('.related-products__container').length) {
 
  try {
    var swiper = new Swiper('.related-products__container', {
      slidesPerView: 1,
      slidesPerGroup: 1,

      breakpoints: {
        720: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 8,
        },

        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 8,
        },
      },

      pagination: {
        el: ".related-pagination",
        type: "fraction",
      },

      navigation: {
        nextEl: ".rel-next",
        prevEl: ".rel-prev",
      },
    });
  } catch (e) {
    console.log(e);
  }
}